import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  margin: 0 auto;

  a {
    color: ${({ theme }) => theme.colors.blue.darkBlue};
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  a:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
    border-radius: 2px;
  }

  @media ${({ theme }) => theme.queries.mobile} {
    align-items: center;
  }

  @media ${({ theme }) => theme.queries.minDesktop} {
    flex-direction: row;
    align-items: center;
    gap: 24px;
    margin-left: 16px;
    flex-wrap: wrap;
    padding-bottom: 0;
    justify-content: space-between;
  }
`;

export const ContactLink = styled.div<{
  $iconColor?: string;
  $linkColor?: string;
}>`
  font-size: 15px;
  line-height: 18px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 8px 0px;
  white-space: nowrap;

  @media ${({ theme }) => theme.queries.minTablet} {
    margin: 0px;
  }

  > svg {
    color: ${({ $iconColor }) => $iconColor};
    margin-right: 8px;
    flex-shrink: 0;
  }

  a {
    color: ${({ $linkColor }) => $linkColor};
  }

  a:hover {
    text-decoration: 'underline';
  }
`;

export const InformationContainer = styled.div<{
  $iconColor?: string;
  $linkColor?: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 250px;
  align-items: center;
  text-align: center;
  padding-top: 32px;

  > svg {
    color: ${({ $iconColor }) => $iconColor};
    margin-right: 8px;
  }

  > a {
    margin: 8px 0px;
    color: ${({ $linkColor }) => $linkColor};
  }
`;

export const ContactInformationContainer = styled.div`
  display: flex;
  gap: 64px;
  flex-wrap: wrap;
  margin-left: 116px;
`;

export const FeedbackContainer = styled.div`
  cursor: pointer;
  margin-top: 16px;

  @media ${({ theme }) => theme.queries.minDesktop} {
    margin-top: 0;
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  align-items: flex-end;

  @media ${({ theme }) => theme.queries.minDesktop} {
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 64px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) and (max-width: 1200px) {
    gap: 32px;
  }
`;
